const META_NAME_PREFIX = 'tagmanager-';

export const getNormalizedMetaData = function () {
  const metaEls = document.querySelectorAll('meta');
  const flatData = {};

  Array.prototype.forEach.call(metaEls, function (metaEl) {
    let name = metaEl.getAttribute('name');

    if (!name || name.indexOf(META_NAME_PREFIX) < 0) return;
    name = name.slice(META_NAME_PREFIX.length);

    const content = metaEl.getAttribute('content');
    if (!content) return;

    flatData[name] = content;
  });

  const result = {};

  Object.keys(flatData).forEach(function (key) {
    if (key.includes('.')) {
      const parts = key.split('.');
      let current = result;

      for (let i = 0; i < parts.length - 1; i++) {
        const part = parts[i];
        current[part] = current[part] || {};
        current = current[part];
      }

      current[parts[parts.length - 1]] = flatData[key];
    } else {
      result[key] = flatData[key];
    }
  });

  return result;
};

export const initialize = function () {
  window.dataLayer = [getNormalizedMetaData()];
};
